import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Huella {
  static async conectarSuprema (ip) {
    const axios = getAxiosInstance()
    const promise = axios.get(`suprema_conectar?r=` +
      `{"parametros": {"ip": "${ip}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { console.log('conectar en modelo ', result); return result.data[0] })
  }

  static async getPerito (ip) {
    const axios = getAxiosInstance()
    const promise = axios.get(`obtener_perito_autorizante_tarjeta?r=` +
      `{"parametros": {"ip": "${ip}"}}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    console.log('Perito Model', response)
    return response.data[0]

    // return promise.then(lrsAdapter, lrsAdapter)
    //  .then((result) => { return result.data[0] })
  }

  static async getEntregador (ip) {
    const axios = getAxiosInstance()
    const promise = axios.get(`obtener_entregador_autorizante?r=` +
      `{"parametros": {"ip": "${ip}"}}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    console.log('Entregador Model', response)
    return response.data[0]

    // return promise.then(lrsAdapter, lrsAdapter)
    //  .then((result) => { return result.data[0] })
  }
}

export default Huella
